import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { connect, useDispatch, useSelector } from 'react-redux';
import './hard-paywall.m.css';
import Icon from '@mdi/react';
import Lottie from 'lottie-react';
import LockIcon from './lock.json';
import { mdiArrowRight } from '@mdi/js';
import TitleWithDivider from '../../molecules/titles/with-divider';
import ListHeaderTitle from '../../atoms/list-header-title';
import {
  getPaymentOptionsAndPay,
  getSSOLoginUrl,
  getSSORedirectUrl,
  getSubscriptionParams,
} from '../../../helpers/subscription-helper';
import { BQLink } from '../../atoms/bqlink';
import Paywallfeatures from './paywall-features';
import SubscribeModal from '../../pages/subscription/subscribe/subscribeModal';
import Loader from '../../atoms/loader';
import ShineButton from '../../atoms/shine-button';
import { PATH } from '../../../constants';

const HardPaywall = ({ hardPayWallEnabled, features, isLoggedIn, userProfile, integrations }) => {
  const skeletonArray = [1, 2, 3];
  const [isLogged, setLogged] = useState(false);
  const [paymentLoader, setPaymentLoader] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [plans, setPlans] = useState([]);
  const [isIndex, setIndex] = useState(1);
  const [amount, setAmount] = useState();
  const [selectedPlan, setSelectedPlan] = useState();
  const [activeSubscription, setActiveSubscription] = useState(null);
  const [redirectUrl, setRedirectUrl] = useState('');
  const [loginUrl, setLoginUrl] = useState('');
  const isSubscriber = useSelector((state) => get(state, ['userData', 'isSubscriber'], null));
  const SSO_LOGIN_URL = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'subscription', 'login_url'], null)
  );
  const active_plans = features?.subscription?.active_plans_id;

  useEffect(() => {
    const url = new URL(window?.location?.href);
    getSSORedirectUrl(url).then((pageUrl) => {
      setRedirectUrl(pageUrl);
    });
  }, []);

  useEffect(() => {
    getSSOLoginUrl(
      integrations?.sso?.client_id,
      integrations?.sso?.client_secret,
      redirectUrl,
      SSO_LOGIN_URL
    ).then((pageUrl) => {
      setLoginUrl(pageUrl);
    });
  }, [redirectUrl]);

  useEffect(() => {
    hardPayWallEnabled();
  }, [hardPayWallEnabled]);

  useEffect(() => {
    setLogged(isLoggedIn);
  }, [isLoggedIn]);

  useEffect(() => {
    if (!isSubscriber) {
      global.AccessType.getSubscriptionPlans().then((sp) => {
        let plans = sp
          .filter((plan) => plan.enabled === true && active_plans.includes(plan.id))
          .sort((a, b) => a.price_cents - b.price_cents);

        setPlans(plans);
        setSelectedPlan(plans[isIndex]);
        setAmount(plans[1].price_cents / 100);
        setLoading(false);

        const userSelectedPlan = JSON.parse(localStorage.getItem('USER_SELECTED_PLAN'));
        if (userSelectedPlan) {
          setSelectedPlan(userSelectedPlan);
          setAmount(userSelectedPlan?.price_cents / 100);
          plans.map((plan, index) => plan.id === userSelectedPlan.id && setIndex(index));
          var element = document.getElementById('hardpaywall');
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          });
        }
      });
    }
  }, [isSubscriber]);

  const handlePlan = (plan, index) => {
    setIndex(index);
    setAmount(plan?.price_cents / 100);
    setSelectedPlan(plan);
  };

  const handlePayment = async () => {
    setPaymentLoader(true);
    setLoading(true);
    const userInfo = await userProfile;
    const params = await getSubscriptionParams(selectedPlan, userInfo);
    await getPaymentOptionsAndPay(params, 'razorpay', onPaymentSuccess, onPaymentFailure);
  };

  const onPaymentSuccess = async (subscription) => {
    await setActiveSubscription(subscription);
    await setOpen(true);
    await setPaymentLoader(false);
    setLoading(false);
  };

  const onPaymentFailure = () => {
    setLoading(false);
    setPaymentLoader(false);
  };

  const onSubscribe = async () => {
    // selectedPlan;
    await localStorage.setItem('USER_SELECTED_PLAN', JSON.stringify(selectedPlan));
    window.location = loginUrl;
  };

  return (
    <div styleName='hardpaywall-wrap'>
      <img src="/images/white_gradient.png" styleName="white-shadow" />
      <div id="hardpaywall" styleName="story-subscribe-wrap">
        <img src="/images/story_top_img.svg" styleName="top-banner" />
        {/* top section */}
        <div styleName="heading-wrap">
          <div styleName="top-text">
            {!isLogged && (
              <div styleName="subscribe-txt">
                I’m already a Subscriber &nbsp;
                <BQLink href={loginUrl} styleName="signin">
                  Sign In
                </BQLink>
              </div>
            )}
            <div styleName="lock-icon">
              <Lottie
                animationData={LockIcon}
                loop={true}
                autoplay={true}
                styleName="custom-lock"
              />
            </div>
            <span styleName="title">{features.subscription.title || ''}</span>
            <div styleName="sub-title">
              Subscribe to unlock & enjoy all&nbsp;
              <span styleName="profit-plus">Members-only</span>&nbsp;benefits
            </div>
          </div>
        </div>
        {/* card section */}
        <div styleName="subscription-wrap">
          <div styleName="title-wrapper">
            <TitleWithDivider>
              <ListHeaderTitle title="Choose a plan" />
            </TitleWithDivider>
            <div styleName="card-section">
              <div styleName="main-card">
                {!isLoading ? (
                  <>
                    {plans.map((list, index) => {
                      const text = list.description?.split(' ').slice(0, 2).join(' ');
                      return (
                        <div
                          styleName={`card ${isIndex === index ? 'select-card' : ''}`}
                          onClick={() => handlePlan(list, index)}
                        >
                          <div styleName="card-header">
                            {isIndex === index ? (
                              <img
                                src="/icons/ic_radio_button_checked_24px.svg"
                                height="23px"
                                width="23px"
                              />
                            ) : (
                              <img
                                src="/icons/ic_radio_button_unchecked_24px.svg"
                                height="23px"
                                width="23px"
                              />
                            )}
                          </div>
                          <div styleName="card-footer">
                            <div styleName={`duration ${
                                isIndex === index ? "select-duration" : ""
                              }`}>
                              {text.toLowerCase() === 'single month'
                                ? '1 Month'
                                : text.toLowerCase()}
                            </div>
                            <div styleName={`amount ${isIndex === index ? 'select-amt' : ''}`}>
                              ₹{list.price_cents / 100}
                               <span
                                 styleName='tag-amount'>{(index === 0 ? '1,499' : index === 1 ? '3,299' : '5,499')}
                               </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <>
                    {skeletonArray.map((list) => {
                      return (
                        <div styleName={`card`}>
                          <div styleName="card-header">
                            {/* {list === 2 ? (
                              <img
                                src="/icons/ic_radio_button_checked_24px.svg"
                                height="23px"
                                width="23px"
                              />
                            ) : ( */}
                            <img
                              src="/icons/ic_radio_button_unchecked_24px.svg"
                              height="23px"
                              width="23px"
                            />
                            {/* )} */}
                          </div>
                          <div styleName="card-footer">
                            <div styleName="duration-skeleton"></div>
                            <div styleName="amount-skeleton"></div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
              {isLogged ? (
                <>
                  <div onClick={() => handlePayment()}>
                    <ShineButton
                      className="shine-button"
                      size="medium"
                      label={`Continue at ₹${amount}`}
                      rounded="full"
                    >
                      {paymentLoader ? (
                        <Loader
                          loaderSize="small"
                          style={{
                            border: '2px solid #ffffff',
                            borderTopColor: 'transparent',
                          }}
                        />
                      ) : (
                        <Icon path={mdiArrowRight} size={'20px'} />
                      )}
                    </ShineButton>
                  </div>
                  <div styleName="description">
                    Renews automatically. Cancel anytime.
                  </div>
                </>
              ) : (
                <>
                  <div onClick={onSubscribe}>
                    <ShineButton
                      className="shine-button"
                      size="medium"
                      label="Subscribe"
                      rounded="full"
                    ></ShineButton>
                  </div>
                  <div styleName="description">
                    Renews automatically. Cancel anytime.
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {/* subscribe section */}
        <Paywallfeatures />
        <div styleName="bottom-text">
          Still Not convinced ?&nbsp;
          <BQLink href={PATH.SUBSCRIPTION_PAGE} styleName="sub-link">
            Know More
          </BQLink>
        </div>
        <img src="/images/story_bottom_img.svg" styleName="bottom-banner" />
      </div>
      {isOpen && (
        <SubscribeModal isOpen={isOpen} setOpen={setOpen} subscription={activeSubscription} />
      )}
    </div>
  );
};
HardPaywall.propTypes = {};
HardPaywall.defaultProps = {};

const mapStateToProps = (state) => ({
  features: get(state, ['qt', 'config', 'features'], {}),
  integrations: get(state, ['qt', 'config', 'integrations'], {}),
  isLoggedIn: get(state, ['userData', 'isLoggedIn'], false),
  userProfile: get(state, ['userData', 'userProfile'], null),
});

const mapDispatchToProps = (dispatch) => ({
  hardPayWallEnabled: () => {
    dispatch({
      type: 'BQ_HARDPAYWALL_ENABLED',
    });
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(HardPaywall);
